import styled from 'styled-components'

// services
import media from '../../../../services/generateMediaQueries'

// components
import Icon from '../../../../components/ui/Icon/Icon'
import CatalogList from '../../../../components/home/CatalogList/CatalogList'
import CatalogCard from '../../../../components/home/CatalogCard/CatalogCard'

// assets
import rewardsBanner from '../../../../assets/img/rewards/rewardsBanner.webp'
import ZingLogo from '../../../../assets/img/zing.svg'

export const StyledBanner = styled.div.attrs(() => ({
  style: {
    background: `linear-gradient(
        to bottom right,
        rgba(231, 71, 94, 0.95) 0%,
        rgba(235, 118, 50, 0.95) 100%
      ), url('${rewardsBanner}') top / cover no-repeat`,
  },
}))`
  width: 100%;
  height: 430px;

  ${media.lessThan('small')`
      height: 500px;
      padding-top: 70px;
    `}
`

export const BannerContent = styled.div`
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 158px);
  width: 100%;
  // max-width: 1024px;
  height: 430px;
  // margin: 0 auto;
  padding: 0 auto;
  display: flex;
  align-items: center;
`

export const BannerDescription = styled.div`
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #ffffff;
`

export const Heading = styled.div`
  ${media.lessThan('large')`
      padding: 0 1.5rem;
    `}

  ${media.lessThan('small')`
      padding: 0 1rem;
    `}
`

export const FormContainer = styled.div`
  display: flex;
`

export const StyledCatalogList = styled(CatalogList)`
  ${media.lessThan('large')`
    margin: 0 1rem;
    justify-content: space-around;
  `}
`

export const StyledCatalogCard = styled(CatalogCard)`
  margin: 0 0.5rem;
  margin-bottom: 1rem !important;

  ${media.lessThan('small')`
      margin: 0;
    `}
`

export const SearchBar = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border: none;

  border-radius: var(--border-radius-form);
  text-align: left;
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05);
  flex: auto;
  height: 3rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 0 1rem;
`

export const StyledCaret = styled(Icon).attrs({
  name: 'caret',
})`
  color: var(--color-primary);
`

export const RewardsCatalogTitle = styled.h2`
  font-size: 2rem;
  margin: 0;
  text-transform: uppercase;
  text-align: center;

  ${media.lessThan('small')`
      font-size: 1.375rem;
    `}
`

export const RewardsCatalogDescription = styled.p`
  font-size: 1.5rem;
  margin: 1rem 0 2rem;
  text-align: center;

  ${media.lessThan('small')`
      font-size: 1.125rem;
    `}
`

export const StyledZingLogo = styled.img.attrs({ src: ZingLogo })`
  display: none;

  ${media.lessThan('small')`
      display: block;
    `}
`
